import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import { translator } from "../utils/translator";
import { type StudentDocs } from "../types/user";
import { type Document } from "../types/docs";

const columnHelper = createColumnHelper<StudentDocs>();

export const StudentDocsTableDef = ({
  directory,
  filenames,
  onClickFile,
}: {
  directory: string;
  filenames: string[];
  onClickFile: ({
    file,
    studentId,
    userCode,
  }: {
    file: Document;
    studentId: number;
    userCode: string;
  }) => void;
}): ColumnDef<StudentDocs, any>[] => [
  columnHelper.accessor("user_code", {
    cell: (info) => <span>{info.getValue()}</span>,
    header: "학생코드",
  }),
  columnHelper.accessor("name", {
    cell: (info) => <span>{info.getValue()}</span>,
    header: "이름",
  }),
  columnHelper.accessor("status", {
    cell: (info) => <span>{translator[info.getValue() || "empty"]}</span>,
    header: "상태",
  }),
  columnHelper.accessor("department", {
    cell: (info) => <span>{translator[info.getValue()]}</span>,
    header: "구분",
  }),
  columnHelper.accessor("course", {
    cell: (info) => <span>{translator[info.getValue()]}</span>,
    header: "과정",
  }),
  columnHelper.accessor("training_type", {
    cell: (info) => <span>{translator[info.getValue()]}</span>,
    header: "실습 유형",
  }),
  columnHelper.accessor("timetable", {
    cell: (info) => <span>{translator[info.getValue()]}</span>,
    header: "시간",
  }),
  columnHelper.group({
    header: directory,
    columns: filenames.map((filename: string) => {
      return columnHelper.accessor(`docs.${filename}`, {
        cell: (info) => {
          const file = info.getValue();
          const { id, user_code } = info.row.original;
          return file ? (
            <button
              className="line-button"
              onClick={() =>
                onClickFile({ file, studentId: id, userCode: user_code })
              }
            >
              <span>{translator[file.status || "empty"]} 보기</span>
            </button>
          ) : (
            "-"
          );
        },
        header: filename,
      });
    }),
  }),
];
